module.exports = __webpack_public_path__ + "static/media/baleine2.ac1d0973.jpg";